import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Randomizer(props) {
  const millsAds = [
    {
      image: '/dracula-2021/ads/afcu.jpg',
      link: 'https://www.americafirst.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'America First Credit Union ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/aladdin.jpg',
      link: 'https://aladdinskylights.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Aladdin Skylights ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/bmw.jpg',
      link: 'https://www.bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'BMW of Utah ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/Challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Challenger School ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/daynes.jpg',
      link: 'https://www.daynesmusic.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Daynes Music ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/Hamilton.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Hamilton Park Interiors ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/Harmons.jpg',
      link: 'https://www.harmonsgrocery.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Harmons ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/jbr.jpg',
      link: 'https://cenexelresearch.com/jbr/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'JBR research ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/lhmiller-lexus.jpg',
      link: 'https://www.lhmlexus.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Larry H. Miller Lexus ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/pbs.jpg',
      link: 'https://www.pbsutah.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'PBS Utah ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/pc-gallery.jpg',
      link: 'https://www.parkcitygalleryassociation.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Park City Gallery Association ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/RCWilley.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'RC Willey ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/regency-royale.jpg',
      link: 'http://www.regencyroyale.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'RC Willey ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/Rubys_Inn_fall.jpg',
      link: 'https://www.rubysinn.com/fallstagearts/',
      alt: 'Rubys Inn ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Tuacahn Amphitheatre ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/u-dept-dance.jpg',
      link: 'https://tickets.utah.edu/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University of Utah Dance ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/UniversityCU.jpg',
      link: 'https://www.ucreditu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'University Federal Credit Union ad',
      cldracula: 'webFormat',
    },
    {
      image: '/dracula-2021/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=balletwest',
      alt: 'Werners ad',
      cldracula: 'webFormat',
    },
  ];

  const [randomAd] = React.useState(
    millsAds[Math.floor(Math.random() * millsAds.length)]
  );

  return (
    <>
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          cldraculaName={randomAd.cldracula}
        />
      </OutboundLink>
      <br />
      <br />
      <hr />
      <br />
    </>
  );
}

export default Randomizer;
